import React from 'react';
import classNames from 'classnames';

class DownArrow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: false,
    };
    this.updateHiddenState = this.updateHiddenState.bind(this);
  }

  static scrollPast(scrollPastId) {
    window.scrollTo({
      top: document.getElementById(scrollPastId).offsetHeight,
      behavior: 'smooth'
    });
  }

  updateHiddenState() {
    const offset = window.pageYOffset || document.documentElement.scrollTop;
    if (offset > 0) {
      this.setState({hidden: true});
    } else {
      this.setState({hidden: false});
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.updateHiddenState, false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.updateHiddenState, false);
  }

  render() {
    return (
      <div className={classNames('down-arrow', {'hidden': this.state.hidden})}
           onClick={() => {
             DownArrow.scrollPast(this.props.scrollPastId)
           }}
      />
    )
  }
}

export default DownArrow;


// WEBPACK FOOTER //
// ./src/parts/DownArrow.js